import { trackEvent } from '@/lib/posthog';
import type { VehicleSort } from './vehicleSort';

function trackConsented(event: string, properties: Record<string, string | number | boolean>) {
  try {
    if (typeof window === 'undefined' || window.localStorage.getItem('gdpr_banner_version') !== 'v2.3' || window.localStorage.getItem('gdpr_tracking_consent') !== 'true') return;
    trackEvent(event, properties);
  } catch { /* Analytics must not prevent navigation. */ }
}

export function trackHeroSearch(categoryTab: 'used' | 'truck' | 'motorcycle') {
  trackConsented('hero_search_submit', { category_tab: categoryTab });
}

export function trackVehiclesSort(sort: VehicleSort) {
  trackConsented('vehicles_sort_change', { sort });
}
export function trackLandingPageView(slug: string, listingCount: number) {
  trackConsented('landing_page_view', { page_slug: slug, listing_count: listingCount });
}
export function trackValuationSubmit(hasEstimate: boolean, context: 'evaluare' | 'vinde' = 'evaluare') {
  trackConsented('valuation_submit', { has_estimate: hasEstimate, context });
}

// Sell funnel (/vinde-masina, RO). No vehicle data or amounts are sent.
export function trackSellValuationView() {
  try {
    if (typeof window === 'undefined' || window.sessionStorage.getItem('ram_sell_val_view')) return;
    window.sessionStorage.setItem('ram_sell_val_view', '1');
  } catch { /* ignore */ }
  trackConsented('sell_valuation_view', { source: 'vinde' });
}
export function trackSellValuationPublishClick(hasEstimate: boolean) {
  trackConsented('sell_valuation_publish_click', { has_estimate: hasEstimate });
}
export function trackSellPackageSelect(pkg: string, afterValuation: boolean) {
  trackConsented('sell_package_select', { pkg, after_valuation: afterValuation });
}
export function trackSellFormPrefillApplied(fieldsCount: number, hasPriceHint: boolean, withAi: boolean) {
  trackConsented('sell_form_prefill_applied', { fields_count: fieldsCount, has_price_hint: hasPriceHint, with_ai: withAi });
}
export function trackSellPriceHintUsed() {
  trackConsented('sell_price_hint_used', { used: true });
}

// Listing page price alerts card: which options the visitor activated. No email or price sent.
export function trackListingWatchSubmit(watch: boolean, similar: boolean) {
  trackConsented('listing_watch_submit', { watch, similar });
}
